import { CookiesBarTheme } from "@acin.reactjs/acin-ui/cookiesBar";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";

const cookiesBarTheme: ComponentCSSStyle<CookiesBarTheme> = {
  root: { zIndex: 9999, color: "white" },
  acceptButton: {
    label: { color: "white" },
    hover: {
      label: {
        color: "white",
      },
    },
    focused: {
      label: {
        color: "white",
      },
    },
    active: {
      label: {
        color: "white",
      },
    },
  },
  rejectButton: {
    label: { color: "white" },
    hover: {
      label: {
        color: "white",
      },
    },
    focused: {
      label: {
        color: "white",
      },
    },
    active: {
      label: {
        color: "white",
      },
    },
  },
};

export default cookiesBarTheme;
